<template>
  <viewData is-edit :info="info" />
</template>
<script>
import { importApi } from '@/api';
import viewData from './components/viewData.vue';
export default {
  name: 'BusinessImportGeneralEdit',
  components: { viewData },
  data() {
    return {
      info: {},
    };
  },
  computed: {
    id() {
      return this.$route.query.id || '';
    },
  },
  mounted() {
    this.reFresh();
  },
  methods: {
    reFresh() {
      importApi
        .getDetailImportTemplateHeaders({
          templateId: this.id,
        })
        .then(res => {
          this.info = res;
        });
    },
  },
};
</script>
